/* MyCase LP 計測（Clarity カスタムイベント + Shopify.analytics.publish）
 * - Shopify.analytics.publish('mce:lp', {event, ...}) をカスタムピクセル「MyCase LP sections → GA4」が
 *   受けて、event 名のまま GA4 へ転送する（セクション追加時もピクセル側の修正は不要）
 * - 各セクションが画面に入ったら1回だけ lp_view_<name> を送る
 * - 最深到達セクションを Clarity のカスタムタグ lp_max_section に記録
 * - CTA / 動画 / E-Ink / ギャラリー切替のクリックを記録
 * 数値の正解は Shopify 側（ShopifyQL）。ここは「どこまで見たか・何を触ったか」専用。
 */
(function () {
  'use strict';
  if (window.__mceAnalyticsLoaded) return;
  window.__mceAnalyticsLoaded = true;

  var NAME_MAP = { judge_me_reviews_homepage: 'reviews', mce_product_meta: 'meta' };
  var seen = Object.create(null);
  var maxIndex = -1;
  var debug = /[?&]mce_debug=1/.test(location.search);
  var VERSION = 'light-2026-10-09'; // テーマ・LP構成を変えたら更新（Clarity タグ / GA4 パラメータ lp_version）

  function sectionName(el) {
    var id = el.id || '';
    var raw = id.replace(/^shopify-section-/, '').replace(/^.*__/, '');
    if (NAME_MAP[raw]) return NAME_MAP[raw];
    return raw.replace(/^mce[-_]/, '').replace(/-/g, '_');
  }

  function clarity() {
    try {
      if (typeof window.clarity === 'function') window.clarity.apply(null, arguments);
    } catch (e) {}
  }

  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }

  function track(event, payload) {
    clarity('event', event);
    payload = payload || {};
    payload.event = event;
    payload.version = VERSION;
    publish('mce:lp', payload);
    if (debug) console.log('[mce-analytics]', event, payload);
  }

  function collectSections() {
    var main = document.getElementById('MainContent') || document.body;
    var nodes = main.querySelectorAll('.shopify-section');
    var list = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var name = sectionName(el);
      if (!name || name === 'meta' || name === 'header' || name === 'footer') continue;
      if (el.offsetHeight === 0) continue;
      list.push({ el: el, name: name, index: list.length });
    }
    return list;
  }

  function onSectionSeen(item) {
    if (seen[item.name]) return;
    seen[item.name] = true;
    track('lp_view_' + item.name, { section: item.name, index: item.index });
    if (item.index > maxIndex) {
      maxIndex = item.index;
      clarity('set', 'lp_max_section', item.name);
      clarity('set', 'lp_max_index', String(item.index));
    }
  }

  function observeSections() {
    var sections = collectSections();
    if (!sections.length) return;
    var byEl = new Map();
    sections.forEach(function (s) { byEl.set(s.el, s); });

    if (!('IntersectionObserver' in window)) {
      sections.forEach(onSectionSeen);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var vh = window.innerHeight || 1;
        var enough = entry.intersectionRatio >= 0.25 || entry.intersectionRect.height >= vh * 0.5;
        if (!enough) return;
        var item = byEl.get(entry.target);
        if (!item) return;
        onSectionSeen(item);
        io.unobserve(entry.target);
      });
    }, { threshold: [0, 0.25, 0.5, 1] });
    sections.forEach(function (s) { io.observe(s.el); });
  }

  function closestSectionName(el) {
    var wrap = el.closest ? el.closest('.shopify-section') : null;
    if (wrap) return sectionName(wrap);
    if (el.closest && el.closest('.mce-sticky-buy')) return 'sticky_buy';
    return 'unknown';
  }

  function observeClicks() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var cta = t.closest('a.mce-button, .mce-button');
      if (cta) {
        track('lp_cta_click', { section: closestSectionName(cta), href: cta.getAttribute('href') || '' });
        return;
      }
      if (t.closest('[data-mce-video-open]')) { track('lp_video_open', { section: closestSectionName(t) }); return; }
      if (t.closest('[data-mce-eink-open]')) { track('lp_eink_open', { section: closestSectionName(t) }); return; }
      var choice = t.closest('[data-mce-choice]');
      if (choice) { track('lp_gallery_choice', { choice: choice.getAttribute('data-mce-choice') }); return; }
      if (t.closest('[data-mce-pause]')) { track('lp_video_pause', { section: closestSectionName(t) }); }
    }, true);
  }

  function start() {
    clarity('set', 'lp_version', VERSION);
    observeSections();
    observeClicks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
